'use client';

import { c as _c } from "react/compiler-runtime";
import { Helmet as OriginalHelmet, HelmetProvider } from '@dr.pogodin/react-helmet';
import { Children } from 'react';

// Wrapper that filters out string children (e.g. from `{value && <meta .../>}`
// when value is an empty string) which the library rejects but were harmless
// with the old mock.
const Helmet = t0 => {
  const $ = _c(8);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== children) {
    t1 = Children.toArray(children).filter(_temp);
    $[3] = children;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <OriginalHelmet {...props}>{t1}</OriginalHelmet>;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export { Helmet, HelmetProvider };
function _temp(child) {
  return typeof child !== "string";
}